module.exports = __webpack_public_path__ + "a1c9dc22ff08e42fc2e0bf49b3a93771.jpg";